const config = {
  sideBySide: {
    view: 'sideBySide',
    textKey: 'appointment:navigator.view_options.side_by_side',
    url: '/appointments',
    className: 'c-form-input-group__item',
  },
  agendaWeek: {
    view: 'agendaWeek',
    textKey: 'appointment:navigator.view_options.week',
    url: '/appointments/week',
    className: 'c-form-input-group__item',
  },
  list: {
    view: 'list',
    textKey: 'appointment:navigator.view_options.list',
    url: '/appointments/list',
    className: 'c-form-input-group__item',
  },
};

export default config;
